import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { OpenaiChatComponent } from '../shared/openai-chat/openai-chat.component';

@Injectable({
  providedIn: 'root'
})
export class OpenaiChatService {
  private componentRef: ComponentRef<OpenaiChatComponent>;

  constructor( private resolver: ComponentFactoryResolver,
  private appRef: ApplicationRef,
  private injector: Injector) { }


  loadComponent() {
    
    const factory = this.resolver.resolveComponentFactory(OpenaiChatComponent);
    this.componentRef = factory.create(this.injector);
    this.appRef.attachView(this.componentRef.hostView);
    const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  destroyComponent() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
    }
  }

}
